import React from "react";
import PropTypes from "prop-types";
import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";

const UserManagementMetricCard = ({
  title,
  value,
  icon: Icon,
  tone,
  isLoading = false,
}) => {
  const isWarning = tone === "warning";

  return (
    <div className="col-md-6 col-lg-4 my-3 d-flex-center">
      <Card
        className="h-100 w-100"
        sx={{
          border: "1px solid var(--neutral-200)",
          borderRadius: "var(--radius-container)",
          boxShadow: "none",
        }}
      >
        <CardContent
          className="d-flex justify-content-between align-items-center"
          sx={{ minHeight: 110, px: 3.25, py: 3 }}
        >
          <Box>
            <Typography className="mb-2" variant="body2">
              {title}
            </Typography>
            {isLoading ? (
              <Skeleton variant="text" width={80} height={32} />
            ) : (
              <Typography className="mb-0 fw-sb" variant="h6">
                {value}
              </Typography>
            )}
          </Box>
          <Box
            className="d-inline-flex align-items-center justify-content-center"
            sx={{
              bgcolor: isWarning ? "var(--status-warning-tint)" : "#cbeeea",
              borderRadius: "var(--radius-container)",
              color: isWarning
                ? "var(--status-warning)"
                : "var(--primary-base)",
              height: 48,
              width: 48,
            }}
          >
            <Icon fontSize="medium" />
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

UserManagementMetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  tone: PropTypes.oneOf(["primary", "warning"]).isRequired,
  isLoading: PropTypes.bool,
};

export default UserManagementMetricCard;
